export default "__VITE_ASSET__DZw4N9sn__"